<script setup lang="ts">
import { useListEventUpgrades } from "@/api"
import { UpgradeCard } from "@/components"
import { NoData } from "@/components/ui"
import { useConvertedRouteParam, useTranslation } from "@/composables"
import { SidebarHostEventLayout } from "@/layouts"

definePage({
  meta: {
    requiresAuth: true,
  },
})

const { t } = useTranslation()

const eventVaultId = useConvertedRouteParam("id", "/event/[id]/upgrade/", value => Number(value))

const { data: upgrades, isLoading: isLoadingUpgrades } = useListEventUpgrades(eventVaultId.value)
</script>

<template>
  <SidebarHostEventLayout>
    <h2 class="font-bold font-comfortaa text-lg">
      {{ t("event_upgrade.title") }}
    </h2>
    <br>
    <transition name="gpx-fade" mode="out-in">
      <div v-if="isLoadingUpgrades" class="flex gap-6 flex-wrap">
        <UpgradeCard v-for="(_, index) in 3" :key="index" is-loading />
      </div>
      <div v-else>
        <NoData
          v-if="!upgrades?.length" hide-button :headline="t('event_upgrade.no_upgrades')"
          :content="t('event_upgrade.no_upgrades_content')"
          :button-label="t('event_upgrade.back_to_dashboard')"
        />
        <div v-else class="flex gap-6 flex-wrap">
          <UpgradeCard
            v-for="upgrade in upgrades" :key="upgrade.name"
            :event-vault-id="eventVaultId" :event-upgrade="upgrade"
          />
        </div>
      </div>
    </transition>
  </SidebarHostEventLayout>
</template>
